import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-rgpd-modal',
  templateUrl: './rgpd-modal.component.html',
  styleUrls: ['./rgpd-modal.component.css']
})
export class RgpdModalComponent implements OnInit {

  @Input() acceptRGPD : AbstractControl;

  constructor(
    private translate : TranslateService
  ) {
    
   }

  ngOnInit() {
  }

  getLanguage() : string{
    return this.translate.currentLang;
  }

}
